import { InfoCircleFilled } from "@ant-design/icons";
import { type FunctionComponent } from "react";

import { cn } from "@btnet/utilities-core";

import "./BTIconInfoCircleFilled.less";

import { type IBTIconProps } from "../BTIcon.types";
import { useAntIcon } from "../BTIcon.utilities";

export type IconType = "warning" | "error" | "info";

interface IBTIconInfoCircleFilledProps extends IBTIconProps {
    type?: IconType;
}

export const BTIconInfoCircleFilled: FunctionComponent<IBTIconInfoCircleFilledProps> = (
    baseProps,
) => {
    const [props] = useAntIcon(baseProps);

    return (
        <InfoCircleFilled
            {...props}
            type="info-circle"
            style={{ ...props.style }}
            className={cn("BTIconInfoCircleFilled", props.className, baseProps.type)}
        />
    );
};
